module.exports = __webpack_public_path__ + "static/media/ChanBaohorneado.c2b296a6.jpg";